<template>
    <tip-tap-toolbar v-if="!hideToolbar && !readOnly" :editor="editor" :hide-h3="hideH3" :hide-h4="hideH4" :hide-table="hideTable" :show-align="showAlign" />
    <div class="tip-tap">
        <editor-content :editor="editor" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Highlight from '@tiptap/extension-highlight'
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import TextAlign from '@tiptap/extension-text-align';
import { TableKit } from '@tiptap/extension-table';
import TipTapToolbar from '@/components/TipTapToolbar.vue';

const CustomBulletList = BulletList.extend({
    addAttributes() {
        return {
            class: {
                default: null,
            },
        };
    }
});

const CustomOrderedList = OrderedList.extend({
    addInputRules: undefined
});

export default defineComponent({
    components: {
        EditorContent,
        TipTapToolbar
    },

    // hideToolbar: the parent shows its own TipTapToolbar for this editor (passed along by the focus event)
    // readOnly: displays the content (parsed through the editor schema, so it's safe to show user HTML) without editing
    props: [ 'modelValue', 'hideH3', 'hideH4', 'hideTable', 'showAlign', 'hideToolbar', 'readOnly' ],

    emits: ['update:modelValue', 'focus'],

    data() {
        return {
            editor: null as any
        }
    },

    mounted() {
        this.editor = new Editor({
            content: this.modelValue,
            editable: !this.readOnly,
            extensions: [StarterKit.configure({bulletList: false, orderedList: false}), Highlight.configure({ multicolor: true }), CustomBulletList, CustomOrderedList, TableKit, TextAlign.configure({types: ['heading', 'paragraph']})],
            onUpdate: () => {
                this.$emit('update:modelValue', this.editor.getHTML())
            },
            onFocus: () => {
                this.$emit('focus', this.editor)
            },
            editorProps: { 
              handleDOMEvents: {
                drop: (view, e) => { e.preventDefault(); },
              } 
            },
        })
    },

    watch: {
        modelValue(value) {
            if(this.editor.getHTML() === value) {
                return;
            }
            this.editor.commands.setContent(value);
        }
    },

    beforeUnmount() {
        this.editor.destroy()
    },
})
</script>